import {gtmEvent, loggedOutSegment} from './helpers'

export const appointmentDateTimeSelected = (dateTime) =>
  loggedOutSegment('Selected Appointment Date Time', {dateTime})

export const appointmentFormLoaded = (showroom) =>
  loggedOutSegment('Appointment Form Loaded', {showroom})

export const schedulerLoggedIn = (email) => gtmEvent('schedulerLogin', {email})

export const schedulerRegistered = (email) => gtmEvent('schedulerSignup', {email})
